import {Grid, useTheme} from "@mui/material";
import * as React from "react";
import { useEffect, useState } from "react";
import { useUpdateEffect } from "../../../../utils/common";
import AutocompleteInput from "../atoms/AutocompleteInput";

export default function BetweenInput(props) {
    const theme = useTheme();

    const {values, filterOptions, columnOptions, optionsDict, disabled} = props;
    const {onValueChange, searchDebounce} = props;
    const {selectedValue, selectedField, selectedOperator, selectedFieldId, setSelectedFieldId} = props;
    const {loading, nonManagerDetail} = props;

    const parsedSelectedValue = selectedValue[0]?.id;
    const splitSelectedValue = parsedSelectedValue?.split("-");
    const start = splitSelectedValue?.[0] ?? "";
    const end = splitSelectedValue?.[1] ?? "";

    const [startText, setStartText] = useState(start);
    const [endText, setEndText] = useState(end);
    const [startSelectedValue, setStartSelectedValue] = useState([{label: start, id: start}]);
    const [endSelectedValue, setEndSelectedValue] = useState([{label: end, id: end}]);
    const [startFinal, setStartFinal] = useState(start);
    const [endFinal, setEndFinal] = useState(end);

    /* Component is setup in this way because of how the parent component was built:
    *   1. text HAS to be a string
    *   2. selectedValue HAS to be an array of object(s) */
    useUpdateEffect(() => {
        setStartFinal(startSelectedValue[0]?.id ?? "");
    }, [startSelectedValue]);
    useUpdateEffect(() => {
        setStartFinal(startText);
    }, [startText]);
    useUpdateEffect(() => {
        setEndFinal(endSelectedValue[0]?.id ?? "");
    }, [endSelectedValue]);
    useUpdateEffect(() => {
        setEndFinal(endText);
    }, [endText]);
    useUpdateEffect(() => {
      if(startFinal === "" && endFinal === "") return;
        onValueChange(null, {id: `${startFinal}-${endFinal}`});
    }, [startFinal, endFinal]);

    return (
        <Grid container data-testid="between-input" style={{width: "300px", display: "flex"}}>
            <AutocompleteInput
                disabled={disabled}
                styles={{flex: 1, width: "100%"}}
                values={values}
                filterOptions={filterOptions}
                columnOptions={columnOptions}
                optionsDict={optionsDict}
                onValueChange={(event, value) => setStartSelectedValue([{label: value?.label ?? "", id: value?.id ?? ""}])}
                searchDebounce={searchDebounce}
                selectedValue={startSelectedValue}
                selectedField={selectedField}
                selectedOperator={selectedOperator}
                selectedFieldId={selectedFieldId}
                setSelectedFieldId={setSelectedFieldId}
                loading={loading}
                nonManagerDetail={nonManagerDetail}
                text={startText}
                setText={(text) => {
                    // Remove description from the end of the string
                    const splitText = text.split(" - ");
                    const newText = splitText[0];
                    setStartText(newText);
                }}
            />

            <span style={{
                padding: "0 1em",
                border: `1px solid ${theme.palette.artisticStroke200.main}`,
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
            }}>
                -
            </span>

            <AutocompleteInput
                disabled={disabled}
                styles={{maxWidth: "150px"}}
                values={values}
                filterOptions={filterOptions}
                columnOptions={columnOptions}
                optionsDict={optionsDict}
                onValueChange={(event, value) => setEndSelectedValue([{label: value?.label ?? "", id: value?.id ?? ""}])}
                searchDebounce={searchDebounce}
                selectedValue={endSelectedValue}
                selectedField={selectedField}
                selectedOperator={selectedOperator}
                selectedFieldId={selectedFieldId}
                setSelectedFieldId={setSelectedFieldId}
                loading={loading}
                nonManagerDetail={nonManagerDetail}
                text={endText}
                setText={(text) => {
                    // Remove description from the end of the string
                    const splitText = text.split(" - ");
                    const newText = splitText[0];
                    setEndText(newText);
                }}
            />
        </Grid>
    );
}
